module.exports = __webpack_public_path__ + "static/media/niveau-03.7c702c72.png";